import { Box, ThemeProvider } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import TopBar from "../components/TopBar";
import theme from "../theme/theme";

function MainLayout() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f1f5f9" }}>
        <Sidebar />
        <Box sx={{ width: 260 }} />

        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
          <TopBar />

          <Box sx={{ flex: 1, p: 3, overflowY: "auto" }}>
            <Box sx={{ maxWidth: 1600, mx: "auto" }}>
              <Outlet />
            </Box>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default MainLayout;